import { Component } from 'react';
import PropTypes from 'prop-types';
import mint from '@tunein/mint';
import withAdRegistration from 'src/common/decorators/ads/withAdRegistration';
import { isLarge } from '../../utils/breakpoints';
import css from './preroll.module.scss';

// disable linting because this needs to be a class or it blows up
// in withAdRegistration call.
// eslint-disable-next-line react/prefer-stateless-function
class PrerollAdSlot extends Component {
  static propTypes = {
    slotName: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    breakpoint: PropTypes.number.isRequired,
  };

  componentDidMount() {
    mint.updateState(
      'isScreenBigEnoughForVideoAds',
      isLarge(this.props.breakpoint),
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.breakpoint !== prevProps.breakpoint) {
      mint.updateState(
        'isScreenBigEnoughForVideoAds',
        isLarge(this.props.breakpoint),
      );
    }
  }

  render() {
    return <div id={this.props.id} className={css.prerollAdSlot} />;
  }
}

export default withAdRegistration({
  autoPlay: false,
  refreshOnPageChange: false,
  // audioAdSlots are unaffected by pagechanges so we just pass false
  checkPageChange: false,
})(PrerollAdSlot);
